export const ZIP_CODE_FIELD = 'ZIP_CODE_FIELD';



// WEBPACK FOOTER //
// ./src/lib/card-field-names.js